export SpeedDial from './SpeedDial';
export SpeedDialItem from './SpeedDialItem';



// WEBPACK FOOTER //
// ./src/components/SpeedDial/index.js